import React from 'react';
import { Outlet } from 'react-router-dom';

import Nav from '../Nav';

export default function SettingsPage() {
  return (
    <div id="settings" className="container container-padded">
      <div className="row">
        <div className="col-sm-12 col-md-3">
          {/* TODO: Fetch activeItem from url */}
          <Nav activeItem="Team Subscriptions" />
        </div>
        <div className="col-sm-12 col-md-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
